import InventoryTableHeader from './InventoryTableHeader';

export default InventoryTableHeader;
export { InventoryTableHeader };
